var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0014 12.0738C24.0014 5.40562 18.6285 0 12.0007 0C5.37289 0 0 5.40562 0 12.0738C0 18.1002 4.38848 23.0952 10.1256 24.0009V15.5639H7.07854V12.0738H10.1256V9.4138C10.1256 6.3878 11.9172 4.71633 14.6584 4.71633C15.9714 4.71633 17.3448 4.95215 17.3448 4.95215V7.92344H15.8315C14.3407 7.92344 13.8758 8.85413 13.8758 9.80896V12.0738H17.2041L16.6721 15.5639H13.8758V24.0009C19.6129 23.0952 24.0014 18.1002 24.0014 12.0738Z",
    fill: "#425893"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e2d432ad9bc1d16155ec198bbf33fb82.svg";
export { ForwardRef as ReactComponent };